import { gql } from "@apollo/client";
import { PayTypeNoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { PayType as PayTypeEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import PayType from "../../data/model/PayType";

import { EntityResourceDefinition } from "../entity-resource-definition";
import { SyncProgressStatus } from "../page-query";

const paymentTypesQuery = gql`
  ${PayTypeNoNestingFragment}
  query GetPayTypes($options: PayTypeListFilterOptions) {
    payTypes(filter: $options) {
      ...PayTypeNoNesting
    }
  }
`;

export const payTypeDefinition = new EntityResourceDefinition<
  PayTypeEntity,
  PayType
>({
  entity: "pay_types",
  query: paymentTypesQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.name = fetchedEntity.name || "";
    newEntity.internal = fetchedEntity.internal;
    newEntity.description = fetchedEntity.description || "";
    newEntity.subtext = fetchedEntity.subtext || "";
    newEntity.logo = fetchedEntity.logo || null;
    newEntity.available = fetchedEntity.available;
    newEntity.onlineOnly = fetchedEntity.onlineOnly;
    newEntity.configurationUrl = fetchedEntity.configurationUrl || null;
    newEntity.defaultGatewayUrl = fetchedEntity.defaultGatewayUrl || null;
    newEntity.platforms = fetchedEntity.platforms ?? [];
    newEntity.channels = fetchedEntity.channels ?? [];
  },
  fetchEntities: (options) => {
    return client
      .query({
        query: paymentTypesQuery,
        variables: {
          options: {
            updatedAt: options?.after,
            channels: ["pos"],
          },
        },
      })
      .then(async (res) => {
        const progressCallback = options?.progressCallback;

        await progressCallback?.({
          fetched: res.data.payTypes.length,
          estimatedTotalItems: res.data.payTypes.length,
          status: SyncProgressStatus.FETCHING,
          totalItems: res.data.payTypes.length,
        });

        return res.data.payTypes;
      });
  },
});
